import React, { useContext, useState } from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';

import secrets from 'app/secrets';
import AuthContext from 'app/src/contexts/AuthContext';

import ClickOutside from '../elements/ClickListener';
import Modal from '../elements/Modal';
import NewSale from './Sales/new';
import Settings from './Settings';
import ResetLinks from './ResetLinks';

import * as colors from '../styles/colors';
import AccountMenu from './account/Menu';
import Notifications from './Notifications';
import { HR } from '../elements';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 0.5;
  align-items: center;
  height: 78px;
  z-index: 10000;
`;

const NavBarSection = styled(View)`
  min-height: 18px;
`;

const NavBarLinkContainer = styled(View)`
  position: absolute;
  display: flex;
  justify-content: column;
  margin-top: 25px;
  border: 1px solid red;
  padding: 20px;
  background-color: #fff;
  width: 200px !important;
  border-radius: 5px;
`;

const NavBarLink = styled(View)`
  padding-top: 5px;
  padding-bottom: 5px;
`;

const HeaderNavigation = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { user, hasPolicy } = useContext(AuthContext);
  const [currentExploded, setCurrentExploded] = useState();
  const [showAddSaleModal, setShowAddSaleModal] = useState();
  const [showSettingsModal, setShowSettingsModal] = useState();
  const [showResetLinksModal, setShowResetLinksModal] = useState();

  const collapse = () => setCurrentExploded('');

  return (
    <ClickOutside
      onClick={() => {
        setCurrentExploded('');
        // setShowMenu(false);
      }}
      className={'header-navigation-links'}
    >
      <NavbarContainer>
        {hasPolicy({ type: 'Seller', action: 'index' }) && (
          <NavBarSection>
            <Link to={`/sellers`} onClick={collapse}>
              <Text>Sellers</Text>
            </Link>
          </NavBarSection>
        )}
        {hasPolicy({ type: 'Asset', action: 'index' }) && (
          <NavBarSection>
            <Pressable
              onPress={() => setCurrentExploded(
                currentExploded === 'assets' ? '' : 'assets'
              )}
            >
              <Text>Assets</Text>
            </Pressable>
            {currentExploded === 'assets' &&
              <NavBarLinkContainer id='assets-links'>
                <NavBarLink>
                  <Link to={`/assetsImport`}
                    onClick={collapse}
                  >
                    <Text>Import Assets</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/title-logs" onClick={collapse}>
                    <Text>Title Logs</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/releases" onClick={collapse}>
                    <Text>Releases</Text>
                  </Link>
                </NavBarLink>
              </NavBarLinkContainer>
            }
          </NavBarSection>
        )}
        {hasPolicy({ type: 'Sale', action: 'index' }) && (
          <NavBarSection>
            <Pressable
              onPress={() => setCurrentExploded(
                currentExploded === 'sales' ? '' : 'sales'
              )}
            >
              <Text>Sales</Text>
            </Pressable>
            {currentExploded === 'sales' &&
              <NavBarLinkContainer>
                <NavBarLink>
                  <Link to={`/sales`} onClick={collapse}>
                    <Text>View Sales</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Pressable
                    onPress={() => {
                      setCurrentExploded(true);
                      setShowAddSaleModal(true);
                    }}
                  >
                    <Text>Add a New Sale</Text>
                  </Pressable>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/sales/recurring-sales" onClick={collapse}>
                    <Text>Recurring Sales</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/sales/1/pre-bids" onClick={collapse}>
                    <Text>Pre-Bids</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/bidding/buyers/1" onClick={collapse}>
                    <Text>Buyer Lot Views</Text>
                  </Link>
                </NavBarLink>
                <HR />
                <NavBarLink>
                  <Link to="/buyers" onClick={collapse}>
                    <Text>Buyers</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/conversations" onClick={collapse}>
                    <Text>Chat Conversations</Text>
                  </Link>
                </NavBarLink>
              </NavBarLinkContainer>
            }
          </NavBarSection>
        )}
        {!hasPolicy({ type: 'Sale', action: 'bidding_only' }) && (
          <NavBarSection>
            <Link to="/reports">
              <Text>Reports</Text>
            </Link>
          </NavBarSection>
        )}
        {user?.accounting && (
          <NavBarSection>
            <Pressable
              onPress={() => setCurrentExploded(
                currentExploded === 'accounting' ? '' : 'accounting'
              )}
            >
              <Text>Accounting</Text>
            </Pressable>
            {currentExploded === 'accounting' &&
              <NavBarLinkContainer>
                {user && (user.accounting) &&
                  <>
                    {secrets.app.doubleEntry ? (
                      <>
                        <NavBarLink>
                          <Link to="/accounting" onClick={collapse}>
                            <Text>Dashboard</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/expenses" onClick={collapse}>
                            <Text>Expenses</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/invoices" onClick={collapse}>
                            <Text>Invoices</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link
                            to="/accounting/credit-memos"
                            onClick={collapse}
                          >
                            <Text>Customer Credits</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/payments" onClick={collapse}>
                            <Text>Receive Payments</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/import" onClick={collapse}>
                            <Text>Quickbooks Import</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/ach-batches" onClick={collapse}>
                            <Text>ACH Batches</Text>
                          </Link>
                        </NavBarLink>
                      </>
                    ) : (
                      <NavBarLink>
                        <Link to="/accounts-payable" onClick={collapse}>
                          <Text>Accounts Payable</Text>
                        </Link>
                      </NavBarLink>
                    )}
                    {/*
                      <NavBarLink>
                        <Link
                          to="/accounts-receivable"
                          onClick={collapse}
                        >
                          <Text>Accounts Receivable</Text>
                        </Link>
                      </NavBarLink>
                    */}
                    <HR />
                    <NavBarLink>
                      <Link
                        to={`/accounting/paddle-service-payments`}
                        onClick={collapse}
                      >
                        <Text>Paddle Service Payments</Text>
                      </Link>
                    </NavBarLink>
                    <HR />
                    <NavBarLink>
                      <Link to={`/vendors`} onClick={collapse}>
                        <Text>Vendors</Text>
                      </Link>
                    </NavBarLink>
                    {secrets.app.doubleEntry && (
                      <>
                        <NavBarLink>
                          <Link to="/accounting/accounts" onClick={collapse}>
                            <Text>Accounts</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link
                            to="/accounting/reconciliation"
                            onClick={collapse}
                          >
                            <Text>Bank Reconciliation</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link
                            to="/accounting/payment-terms"
                            onClick={collapse}
                          >
                            <Text>Payment Terms</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/fee-markups" onClick={collapse}>
                            <Text>Default Fee Markups</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/fee-types" onClick={collapse}>
                            <Text>Fee Types</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/reports" onClick={collapse}>
                            <Text>Accounting Reports</Text>
                          </Link>
                        </NavBarLink>
                        <NavBarLink>
                          <Link to="/accounting/transactions" onClick={collapse}>
                            <Text>All Transactions</Text>
                          </Link>
                        </NavBarLink>
                      </>
                    )}
                  </>
                }
              </NavBarLinkContainer>
            }
          </NavBarSection>
        )}
        {user?.admin &&
          <NavBarSection>
            <Pressable
              onPress={() => setCurrentExploded('admin')}
            >
              <Text>Admin</Text>
            </Pressable>
            {currentExploded === 'admin' &&
              <NavBarLinkContainer>
                <NavBarLink>
                  <Link to={`/users`} onClick={collapse}>
                    <Text>Users</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to={`/locations`} onClick={collapse}>
                    <Text>Locations</Text>
                  </Link>
                </NavBarLink>
                {hasPolicy({ type: 'Setting', action: 'update' }) && (
                  <NavBarLink>
                    <Pressable
                      onPress={() => setShowSettingsModal(true)}
                    >
                      <Text>Settings</Text>
                    </Pressable>
                  </NavBarLink>
                )}
                <NavBarLink>
                  <Pressable
                    onPress={() => setShowResetLinksModal(true)}
                  >
                    <Text>Password Resets</Text>
                  </Pressable>
                </NavBarLink>
                <HR />
                {user?.canAccessCommissions &&
                  <View>
                    <NavBarLink>
                      <Link
                        to="/commissions-and-salespeople"
                        onClick={collapse}
                      >
                        <Text>Commission Structures and Salespeople</Text>
                      </Link>
                    </NavBarLink>
                    <HR />
                  </View>
                }
                <NavBarLink>
                  <Link to={`/paddle-services`} onClick={collapse}>
                    <Text>Paddle Services</Text>
                  </Link>
                </NavBarLink>
                <NavBarLink>
                  <Link to="/pre-bid-schedules" onClick={collapse}>
                    <Text>Pre-Bid Pricing Schedules</Text>
                  </Link>
                </NavBarLink>
                <HR />
                <NavBarLink>
                  <Link to={`/inactive-resources`} onClick={collapse}>
                    <Text>Inactive Resources</Text>
                  </Link>
                </NavBarLink>
                <HR />
                <NavBarLink>
                  <Link to={`/blog`} onClick={collapse}>
                    <Text>Blog</Text>
                  </Link>
                </NavBarLink>
              </NavBarLinkContainer>
            }
          </NavBarSection>
        }
        {user && <Notifications user={user} />}
        <FontAwesomeIcon
          icon={faCircleUser}
          size='2xl'
          style={{color: colors.elRed}}
          onClick={() => setShowMenu(!showMenu)}
        />
        <AccountMenu showMenu={showMenu} setShowMenu={setShowMenu} />
      </NavbarContainer>
      {showAddSaleModal &&
        <Modal
          showModal={showAddSaleModal}
          setShowModal={setShowAddSaleModal}
          modalType={'Add Sale'}
        >
          <NewSale
            setShowModal={setShowAddSaleModal}
            fromNav={true}
          />
        </Modal>
      }
      {showSettingsModal &&
        <Modal
          showModal={showSettingsModal}
          setShowModal={setShowSettingsModal}
          modalType={'Update Settings'}
        >
          <Settings
            setShowModal={setShowSettingsModal}
            fromNav={true}
          />
        </Modal>
      }
      {showResetLinksModal &&
        <Modal
          showModal={showResetLinksModal}
          setShowModal={setShowResetLinksModal}
          modalType={'Get Password Reset Link'}
        >
          <ResetLinks setShowModal={setShowResetLinksModal} />
        </Modal>
      }
    </ClickOutside>
  )
};

export default HeaderNavigation;
